import { useState, type JSX } from 'react';
import { AccountsPanel } from './AccountsPanel';
import { CampaignsPanel } from './CampaignsPanel';

type OutreachTab = 'accounts' | 'campaigns';

export function OutreachScreen(): JSX.Element {
  const [tab, setTab] = useState<OutreachTab>('accounts');

  return (
    <div className="dx-pane">
      <div className="dx-pane-header">
        <div>
          <div className="dx-pane-title">Outreach</div>
          <div className="dx-pane-meta">Manage TikTok accounts and DM campaigns</div>
        </div>
        <div className="dx-segmented">
          <button
            type="button"
            className={tab === 'accounts' ? 'is-active' : ''}
            onClick={() => setTab('accounts')}
          >
            Accounts
          </button>
          <button
            type="button"
            className={tab === 'campaigns' ? 'is-active' : ''}
            onClick={() => setTab('campaigns')}
          >
            Campaigns
          </button>
        </div>
      </div>

      {tab === 'accounts' ? <AccountsPanel /> : <CampaignsPanel />}
    </div>
  );
}
